import PaginationSection, { PaginationSection as PaginationSectionComponent } from './PaginationSection'
export { PaginationSectionComponent as PaginationSection }
export default PaginationSection
